export const checkMotion = ({ checkIsDesktop, menu }: { checkIsDesktop: boolean; menu: boolean }) => {
  return checkIsDesktop
    ? {
        initial: { x: -300 },
        animate: { x: menu ? 0 : -300 },
        transition: { duration: 0.5 },
      }
    : {
        initial: { x: 300 },
        animate: { x: menu ? 0 : 300 },
        transition: { duration: 0.5 },
      }
}
